import { Component, Input, OnInit } from '@angular/core';
import { CompanyEnum } from '../../models/company.model';
import { ExamPreparation } from '../../models/pricelist-exam-preparation.model';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { CommonModule } from '@angular/common';
import { MoreInfoListComponent } from '../more-info/more-info-list/more-info-list.component';
import { NameAndPrice, ProductsWithPriceAndNoteLabels, ProductWithPriceAndAdditionalInfo } from '../../models/types';
import { getExamPreparationLabels } from '../../utils/table-utils';
import { PriceAndNoteTableComponent } from '../price-and-note-table/price-and-note-table.component';
import { Currency } from '../../models/currency.model';

@Component({
  standalone: true,
  imports: [CommonModule, TableHeaderComponent, MoreInfoListComponent, PriceAndNoteTableComponent],
  selector: 'lx-price-lists-portal-exam-preparation',
  templateUrl: './exam-preparation.component.html',
  styleUrls: ['./exam-preparation.component.scss', './print-exam-preparation.component.scss'],
})
export class ExamPreparationComponent implements OnInit {
  @Input() examPreparation!: ExamPreparation;
  @Input() currency: Currency | undefined;
  @Input() company: CompanyEnum = CompanyEnum.KIL;

  moreInfoData: Record<string, NameAndPrice[]> | undefined;

  dataSource: ProductWithPriceAndAdditionalInfo[] = [];
  columnLabels: ProductsWithPriceAndNoteLabels | undefined;

  ngOnInit(): void {
    this.moreInfoData = this.examPreparation?.info?.reduce<Record<string, NameAndPrice[]>>((moreInfo, info) => {
      const allMoreInfo = { ...moreInfo };
      allMoreInfo[info.title] = info.notes?.map((note) => ({ name: note }));
      return allMoreInfo;
    }, {});

    this.columnLabels = getExamPreparationLabels();
    this.dataSource = this.examPreparation?.products?.map(({ program, fee, note }) => ({
      name: program,
      price: fee,
      additionalInfo: note,
    }));
  }
}
